import { render, staticRenderFns } from "./LoaderGlobal.vue?vue&type=template&id=724546a1&"
import script from "./LoaderGlobal.vue?vue&type=script&lang=js&"
export * from "./LoaderGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724546a1')) {
      api.createRecord('724546a1', component.options)
    } else {
      api.reload('724546a1', component.options)
    }
    module.hot.accept("./LoaderGlobal.vue?vue&type=template&id=724546a1&", function () {
      api.rerender('724546a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/LoaderGlobal.vue"
export default component.exports